import React, { useContext } from 'react'
import SspContext from 'selfServicePortal/contexts/SspContext'
import { FormInfo } from 'selfServicePortal/components/FormInfo/FormInfo'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPen } from '@fortawesome/free-solid-svg-icons'
import { useTranslation } from 'react-i18next'
import { MyAccountPages } from '../MyAccount'
import { Heading } from 'selfServicePortal/components'
import './index.scss'
import { useQuery } from '@tanstack/react-query'
import { getContactChangeStatus } from 'selfServicePortal/services/CustomerServices/getContactChangeStatusService'
import { CircleSpinner } from 'shared'
import { getErrorMessage } from 'selfServicePortal/utils'

interface InfoProps {
	onInfoClick: (page: MyAccountPages) => void
}

export function Info({ onInfoClick }: InfoProps) {
	const { t } = useTranslation()
	const { customerData } = useContext(SspContext)
	const contactChangeStatusQuery = useQuery({
		queryFn: () => getContactChangeStatus(customerData?.customerId),
	})

	const renderedHeading = contactChangeStatusQuery.data?.canChangeAddress ? (
		<Heading
			title={t('MyAccountHeading')}
			description={t('MyAccountDescriptionEdit')}
		/>
	) : (
		<Heading
			title={t('MyAccountHeading')}
			description={t('MyAccountDescription')}
		/>
	)

	if (contactChangeStatusQuery.isLoading) {
		return (
			<div className="my-account-info">
				{renderedHeading}

				<div className="contact-info-container">
					<CircleSpinner />
				</div>
			</div>
		)
	}

	if (contactChangeStatusQuery.isError) {
		return (
			<div className="my-account-info">
				{renderedHeading}

				<div className="error">
					{getErrorMessage(contactChangeStatusQuery.error)}
				</div>
			</div>
		)
	}

	return (
		<div className="my-account-info">
			{renderedHeading}

			<div className="contact-info-container">
				<FormInfo
					label={t('Name')}
					value={`${customerData?.firstName} ${customerData?.lastName}`}
					disabled
				/>
				<FormInfo label={t('Address')}>
					<FormInfo.Value
						disabled={
							!contactChangeStatusQuery.data?.canChangeAddress
						}>
						<div>
							<div>{customerData?.city}</div>
							<div>{`${customerData?.street} ${customerData?.houseNumber}`}</div>
							<div>{customerData?.postalCode}</div>
						</div>
					</FormInfo.Value>
					{contactChangeStatusQuery.data?.canChangeAddress ? (
						<FormInfo.FloatRight>
							<button
								className="form-info-button pencil"
								onClick={() => {
									onInfoClick('address')
								}}>
								<FontAwesomeIcon icon={faPen} color="#d8a58c" />
							</button>
						</FormInfo.FloatRight>
					) : null}
				</FormInfo>
				<FormInfo
					label={t('PhoneNumber')}
					value={customerData?.mobilePhoneNumber}
					disabled>
					{/* <FormInfo.FloatRight> */}
					{/* 	<button */}
					{/* 		className="form-info-button" */}
					{/* 		onClick={() => { */}
					{/* 			onInfoClick('phone') */}
					{/* 		}}> */}
					{/* 		<FontAwesomeIcon icon={faPen} color="#d8a58c" /> */}
					{/* 	</button> */}
					{/* </FormInfo.FloatRight> */}
				</FormInfo>
				<FormInfo
					label={t('Email')}
					value={customerData?.email}
					disabled>
					{/* <FormInfo.FloatRight> */}
					{/* 	<button */}
					{/* 		className="form-info-button" */}
					{/* 		onClick={() => { */}
					{/* 			onInfoClick('email') */}
					{/* 		}}> */}
					{/* 		<FontAwesomeIcon icon={faPen} color="#d8a58c" /> */}
					{/* 	</button> */}
					{/* </FormInfo.FloatRight> */}
				</FormInfo>
			</div>
		</div>
	)
}
